<template>
    <div v-if="isEventLoaded && event">
        <MpCombinationSubBet v-bind:subBetKey="subBetKey" v-bind:event="event" />
    </div>
</template>

<script lang="ts" setup>
    import { useThrottleFn } from '@vueuse/core';
    import { toRefs, watch } from 'vue';
    import { MpCombinationContext } from '@/components/mpRecommendation/MpCombinationContext';
    import MpCombinationSubBet from '@/components/mpRecommendation/MpCombinationSubBet.vue';
    import { useEventEmitter } from '@/composable/useEventEmitter';
    import { useMpRecommendationEvent } from '@/core/oddsApi/composable/useMpRecommendationEvent';
    import type { ISubBetKey } from '@/interface/IPopularMixParlay';

    const props = defineProps<{
        subBetKey: ISubBetKey;
    }>();

    const { eventId } = toRefs(props.subBetKey);
    const { event, loaded: isEventLoaded, refetch: refetchEvent, error: eventError } = useMpRecommendationEvent(eventId.value);

    const { removeMpCombination } = MpCombinationContext.inject();

    watch([isEventLoaded, event], () => {
        if (!isEventLoaded.value) {
            return;
        }
        if (!event.value) {
            removeMpCombination();
        }
    });

    watch(eventError, () => {
        if (eventError.value) {
            removeMpCombination();
        }
    });

    const eventEmitter = useEventEmitter();
    const throttledRefetchEvent = useThrottleFn(refetchEvent, 5000, false, true);
    eventEmitter.on('oddsDisplay:refreshMpRecommendation', () => {
        throttledRefetchEvent();
    });
</script>
